import {gsap, ScrollTrigger} from 'gsap/all';
import './components/accordion';
import './components/modal';
import './components/responsive-background-image';
import './components/slider';
import './components/map';

gsap.registerPlugin(ScrollTrigger);

(function ($, window) {
    const $body = $('body'),
        inBackend = $body.hasClass('neos-backend');

    // Remove preload class
    // --------------------

    $(window).on('load', function () {
        $body.removeClass('preload');
    });

    // Page banner
    // --------------------

    if ($('.document-banner').length) {
        const bannerHeight = $('.document-banner').outerHeight(),
            newHeight = Math.round(bannerHeight);
        $body.css('margin-top', newHeight + 'px');
        $('#header').css('top', newHeight + 'px');
    }

    // Menu dropdown toggle
    // --------------------

    $('.submenu-toggle').click(function () {
        $(this).parent().toggleClass('dropdown-active');
    });

    $('#btn-nav-toggle').on('click', function () {
        if ($body.hasClass('has-nav-open')) {
            $body.removeClass('has-nav-open');
            $body.toggleClass('has-nav-closed');
        } else {
            $body.removeClass('has-nav-closed');
            $body.toggleClass('has-nav-open');
        }
    });


    // Scroll into view (toggleClass)
    //-----------------------------------

    const sections = gsap.utils.toArray('section');

    sections.forEach((section) => {
        gsap.from(section, {
            scrollTrigger: {
                start: 'top 80%',
                end: 'bottom top',
                trigger: section,
                toggleClass: 'anm-active',
                once: true
            }
        });
    });




})(jQuery, window, document);
